import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Dashboard',
    main: [
      

      {
        state: 'home',
        name: 'Home',
        type: 'link',
        icon: 'ti-home'
      },
      {
        state: 'dashboard1',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-control-record'
      },
      // {
      //   state: 'dashboard',
      //   name: 'Appointment Summary',
      //   type: 'link',
      //   icon: 'ti-home'
      // },
      // {
      //   state: 'dashboard',
      //   name: 'Service Summary',
      //   type: 'link',
      //   icon: 'ti-home'
      // }
    ]
  },


{
  
  label: 'Booking',
  main: [
    {
      state: 'BookReq',
      name: 'Booking Requests',
      type: 'link',
      icon: 'ti-control-record'
    }
    
    ,
    {
      state: 'booking',
      name: 'Booking',
      type: 'link',
      icon: 'ti-control-record'
    }
    
  ]
},

  
  {
    label: 'Trip Management',
    main: [
     

      {
        state: 'dashboard',
        name: 'Trip Overview',
        type: 'link',
        icon: 'ti-control-record'
      },

      
      {
        state: 'triprpt',
        name: 'Tracking Report',
        type: 'link',
        icon: 'ti-control-record'
      },

      
      
      
    ]
  },



{
  
  label: 'Billing',
  main: [

    {
      state: 'billing',
      name: 'Billing',
      type: 'link',
      icon: 'ti-control-record'
    }
  ]
},

{
  
  label: 'Messaging',
  main: [

    {
      state: 'messaging',
      name: 'Messaging',
      type: 'sub',
      icon: 'ti-control-record',

      children: [
        {
            state: 'composesms',
            name: 'Compose SMS'
        },
        {
            state: 'exsms',
            name: 'Template SMS'
        },]
    },
    // {
    //   state: 'exsms',
    //   name: 'SMS',
    //   type: 'link',
    //   icon: 'ti-control-record'
    // },
  ]
},
  {
  
  label: 'Masters',
  main: [
    // {
    //   state: 'passenger',
    //   name: 'Passenger',
    //   type: 'link',
    //   icon: 'ti-control-record'
    // },
    {
      state: 'custstf',
      name: 'Passenger',
      type: 'link',
      icon: 'ti-control-record'
    },
    {
      state: 'drivers',
      name: 'Drivers',
      type: 'link',
      icon: 'ti-control-record'
    },
    {
      state: 'fuelstat',
      name: 'Fuel Stations',
      type: 'link',
      icon: 'ti-control-record'
    },
    


  ]
},

{
  
  label: 'GPS Device',
  main: [
    {
      state: 'hview',
      name: 'Health View',
      type: 'link',
      icon: 'ti-control-record'
    }
    


  ]
},

{
  
  label: 'User Manager',
  main: [
    {
      state: 'usermanage',
      name: 'Manage Users',
      type: 'link',
      icon: 'ti-control-record'
    }
    ,
    {
      state: 'custmanage',
      name: 'Manage Customers',
      type: 'link',
      icon: 'ti-control-record'
    },
    
  ]
},
];

///////////////////////////////////////////


const BRANCHITEMS = [
  
  {
    
    label: 'Booking',
    main: [
      {
        state: 'BookReq',
        name: 'Booking Requests',
        type: 'link',
        icon: 'ti-control-record'
      }
      
      ,
      {
        state: 'booking',
        name: 'Booking',
        type: 'link',
        icon: 'ti-control-record'
      }
      
    ]
  },
  
  
    {
      label: 'Trip Management',
      main: [
       
  
        {
          state: 'custtrip',
          name: 'Trip Overview',
          type: 'link',
          icon: 'ti-control-record'
        },
  
        {
          state: 'passalot',
          name: 'Passinger Allotment',
          type: 'link',
          icon: 'ti-control-record'
        },
  
      
      ]
    },
    {
      
      label: 'Billing',
      main: [
    
        {
          state: 'billing',
          name: 'Billing',
          type: 'link',
          icon: 'ti-control-record'
        }
      ]
    },
];

/////////////////////////



const DOCITEMS = [
  {
 
    label: 'Dashboard',
    main: [
      {
        state: 'docdash',
        name: 'Dashboard',
        type: 'link',
        icon: 'ti-control-record'
      }

      
    ]
  },
  {
 label: 'Main Navigation',
    main: [
     

      {
        state: 'docpsum',
        name: 'Payment Summary',
        type: 'link',
        icon: 'ti-control-record'
      },

      {
        state: 'docasum',
        name: 'Appointment Summary',
        type: 'link',
        icon: 'ti-control-record'
      },

      {
        state: 'docisum',
        name: 'Item Summary',
        type: 'link',
        icon: 'ti-control-record'
      },
      // {
      //   state: 'dashboard',
      //   name: 'Service Summary',
      //   type: 'link',
      //   icon: 'ti-control-record'
      // },
      
      
    ]
  }
];

////////////////////////////

const staffMENUITEMS = [
  // {
  //   label: 'Dashboard',
  //   main: [
  //     {
  //       state: 'dashboard',
  //       name: 'Dashboard',
  //       type: 'link',
  //       icon: 'ti-control-record'
  //     }

     
  //   ]
  // },

{
  
  label: 'Attendance',
  main: [
    {
      state: 'attendance',
      name: 'Attendance',
      type: 'link',
      icon: 'ti-control-record'
    }

  ]
},


];
@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}

export class StaffMenuItems {
  getAll(): Menu[] {
    return staffMENUITEMS;
  }
}
  export class BRANCHmenuITEMS {
    getAll(): Menu[] {
      return BRANCHITEMS;
    }
  }

    export class Docmenuitems {
      getAll(): Menu[] {
        return DOCITEMS;
      }

  /*add(menu: Menu) {
    MENUITEMS.push(menu);
  }*/
}


// WEBPACK FOOTER //
// D:/Angular projects/memberreg/memberreg/src/app/shared/menu-items/menu-items.ts